import get from 'lodash.get';

const getSingleTemplate = (rootState) => get(rootState, 'templates.single');

export default getSingleTemplate;
